import React from "react";
import { Route, Redirect } from "react-router-dom";

const RedirectWithSearch = ({ from, to, ...otherProps }) => (
    <Route
        path={from}
        render={({ location }) => {
            if (typeof to === "string") {
                to = { pathname: to };
            }

            to = {
                ...to,
                search: location.search,
            };

            return <Redirect {...otherProps} to={to} />;
        }}
    />
);

export default RedirectWithSearch;
